import autoGrow from '@/directives/auto-grow';
import clickOutside from '@/directives/click-outside';
const registerDirectives = (app: any) => {
  app.directive('click-outside', clickOutside);
  app.directive('auto-grow', autoGrow);
};

export default registerDirectives;
